import { render, staticRenderFns } from "./LoyaltyFlagSwitcher.vue?vue&type=template&id=48cd2e48"
import script from "./LoyaltyFlagSwitcher.vue?vue&type=script&lang=js"
export * from "./LoyaltyFlagSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports